import React, { createContext, useContext, useState, useEffect } from 'react';

interface PageTitleContextValue {
  title: string;
  setTitle: (title: string) => void;
  contractName: string | null;
  setContractName: (name: string | null) => void;
}

const PageTitleContext = createContext<PageTitleContextValue>({
  title: '',
  setTitle: () => {},
  contractName: null,
  setContractName: () => {},
});

export const PageTitleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState('');
  const [contractName, setContractName] = useState<string | null>(
    () => sessionStorage.getItem('current_contract_name')
  );

  return (
    <PageTitleContext.Provider value={{ title, setTitle, contractName, setContractName }}>
      {children}
    </PageTitleContext.Provider>
  );
};

export const usePageTitle = (title: string): void => {
  const { setTitle } = useContext(PageTitleContext);
  useEffect(() => {
    setTitle(title);
  }, [title, setTitle]);
};

export const usePageTitleContext = (): PageTitleContextValue => useContext(PageTitleContext);
